function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  x: 906,
  y: 127,
  width: 94,
  height: 95,
  filterUnits: "userSpaceOnUse",
  id: "product-tag_svg__c"
}, /*#__PURE__*/React.createElement("feOffset", {
  dx: 1,
  dy: 1,
  in: "SourceAlpha",
  result: "shadowOffsetInner"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2.5,
  in: "shadowOffsetInner",
  result: "shadowGaussian"
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "shadowGaussian",
  operator: "atop",
  in: "SourceAlpha",
  result: "shadowComposite"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.349019607843137 0",
  in: "shadowComposite"
})), /*#__PURE__*/React.createElement("mask", {
  fill: "#fff",
  id: "product-tag_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M84 85L0 0l38.889.172L84 46.4V85z",
  fillRule: "evenodd"
})), /*#__PURE__*/React.createElement("g", {
  id: "product-tag_svg__b"
}, /*#__PURE__*/React.createElement("path", {
  d: "M84 85L0 0l38.889.172L84 46.4V85z",
  fill: "#28a745",
  transform: "translate(910 131)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M84 85L0 0l38.889.172L84 46.4V85z",
  strokeWidth: 2,
  stroke: "#28a745",
  fill: "none",
  transform: "translate(910 131)",
  mask: "url(#product-tag_svg__a)"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-906 -127)"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#product-tag_svg__b",
  filter: "url(#product-tag_svg__c)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#product-tag_svg__b"
}));

function SvgProductTag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 95
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,77u/PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjxzdmcgdmVyc2lvbj0iMS4xIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgd2lkdGg9Ijk0cHgiIGhlaWdodD0iOTVweCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCiAgPGRlZnM+DQogICAgPG1hc2sgZmlsbD0id2hpdGUiIGlkPSJjbGlwMzMiPg0KICAgICAgPHBhdGggZD0iTSA4NCA4NSAgTCAwIDAgIEwgMzguODg4ODg4ODg4ODg4OSAwLjE3MTcxNzE3MTcxNDY0NyAgTCA4NCA0Ni4zOTk5OTk5OTk5OTc4ICBMIDg0IDg1ICBaICIgZmlsbC1ydWxlPSJldmVub2RkIiAvPg0KICAgIDwvbWFzaz4NCiAgICA8ZmlsdGVyIHg9IjkwNnB4IiB5PSIxMjdweCIgd2lkdGg9Ijk0cHgiIGhlaWdodD0iOTVweCIgZmlsdGVyVW5pdHM9InVzZXJTcGFjZU9uVXNlIiBpZD0iZmlsdGVyMzQiPg0KICAgICAgPGZlT2Zmc2V0IGR4PSIxIiBkeT0iMSIgaW49IlNvdXJjZUFscGhhIiByZXN1bHQ9InNoYWRvd09mZnNldElubmVyIiAvPg0KICAgICAgPGZlR2F1c3NpYW5CbHVyIHN0ZERldmlhdGlvbj0iMi41IiBpbj0ic2hhZG93T2Zmc2V0SW5uZXIiIHJlc3VsdD0ic2hhZG93R2F1c3NpYW4iIC8+DQogICAgICA8ZmVDb21wb3NpdGUgaW4yPSJzaGFkb3dHYXVzc2lhbiIgb3BlcmF0b3I9ImF0b3AiIGluPSJTb3VyY2VBbHBoYSIgcmVzdWx0PSJzaGFkb3dDb21wb3NpdGUiIC8+DQogICAgICA8ZmVDb2xvck1hdHJpeCB0eXBlPSJtYXRyaXgiIHZhbHVlcz0iMCAwIDAgMCAwICAwIDAgMCAwIDAgIDAgMCAwIDAgMCAgMCAwIDAgMC4zNDkwMTk2MDc4NDMxMzcgMCAgIiBpbj0ic2hhZG93Q29tcG9zaXRlIiAvPg0KICAgIDwvZmlsdGVyPg0KICAgIDxnIGlkPSJ3aWRnZXQzNSI+DQogICAgICA8cGF0aCBkPSJNIDg0IDg1ICBMIDAgMCAgTCAzOC44ODg4ODg4ODg4ODg5IDAuMTcxNzE3MTcxNzE0NjQ3ICBMIDg0IDQ2LjM5OTk5OTk5OTk5NzggIEwgODQgODUgIFogIiBmaWxsLXJ1bGU9Im5vbnplcm8iIGZpbGw9IiMyOGE3NDUiIHN0cm9rZT0ibm9uZSIgdHJhbnNmb3JtPSJtYXRyaXgoMSAwIDAgMSA5MTAgMTMxICkiIC8+DQogICAgICA8cGF0aCBkPSJNIDg0IDg1ICBMIDAgMCAgTCAzOC44ODg4ODg4ODg4ODg5IDAuMTcxNzE3MTcxNzE0NjQ3ICBMIDg0IDQ2LjM5OTk5OTk5OTk5NzggIEwgODQgODUgIFogIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZT0iIzI4YTc0NSIgZmlsbD0ibm9uZSIgdHJhbnNmb3JtPSJtYXRyaXgoMSAwIDAgMSA5MTAgMTMxICkiIG1hc2s9InVybCgjY2xpcDMzKSIgLz4NCiAgICA8L2c+DQogIDwvZGVmcz4NCiAgPGcgdHJhbnNmb3JtPSJtYXRyaXgoMSAwIDAgMSAtOTA2IC0xMjcgKSI+DQogICAgPHVzZSB4bGluazpocmVmPSIjd2lkZ2V0MzUiIGZpbHRlcj0idXJsKCNmaWx0ZXIzNCkiIC8+DQogICAgPHVzZSB4bGluazpocmVmPSIjd2lkZ2V0MzUiIC8+DQogIDwvZz4NCjwvc3ZnPg==";
export { SvgProductTag as ReactComponent };